module.exports = __webpack_public_path__ + "img/partners.f119cee2.png";